import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API, LingoApiResponse, Schemas, Space, Kit, Asset } from "@thenounproject/lingo-core";
import * as actionTypes from "../actions/actionTypes";
import qs from "query-string";

const { CALL_API } = API;

interface CustomFieldFetchOptions {
  spaceId: Space["id"];
  kitUuid?: Kit["kitId"];
  assetId?: Asset["id"];
  assetToken?: Asset["shareToken"];
}

export const fetchCustomFields = ({
  spaceId,
  kitUuid,
  assetId,
  assetToken,
}: CustomFieldFetchOptions) => {
  const queryString = qs.stringify({
    kit_uuid: kitUuid,
    asset_uuid: assetId,
    asset_token: assetToken,
  });
  return {
    spaceId,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_CUSTOM_FIELDS,
        actionTypes.FETCH_CUSTOM_FIELDS_SUCCESS,
        actionTypes.FETCH_CUSTOM_FIELDS_FAILURE,
      ],
      endpoint: `/spaces/${spaceId}/fields?${queryString}`,
      method: "GET",
      schema: Schemas.CUSTOM_FIELD,
    },
  };
};

const useCustomFieldsFetch = () => {
  const dispatch = useDispatch();
  return useCallback(
    (args: CustomFieldFetchOptions) => {
      return dispatch(fetchCustomFields(args)) as unknown as Promise<LingoApiResponse>;
    },
    [dispatch]
  );
};
export default useCustomFieldsFetch;
